import React from 'react';

import Card from '../../components/Card/Card';
import ChartWrapper from '../../components/ChartWrapper/ChartWrapper';
import GqlQueryWrapper from '../../components/GqlQueryWrapper/GqlQueryWrapper';
import LineChart from '../../components/LineChart/LineChart';
import TablePreRender from '../../components/Table/Table.prerender';
import TitleWithDescription from '../../components/TitleWithDescription/TitleWithDescription';
import ChartTooltip from '../../components/ChartTooltip/ChartTooltip';
import TimeRangeToggle from '../../components/TimeRangeToggle/TimeRangeToggle';
import ViewDataTable from '../../components/ViewDataTable/ViewDataTable';

import styles from './HistoricalPricesChart.css';
import { historicalPricesChartCardUtil } from './util';

import { displayCurrency } from '../../utils/Format/Format';

import { HISTORICAL_PRICE_QUERY } from './queries';

class HistoricalPricesChart extends React.Component {
    state = {
        filter: [{ count: -1 }],
        selectedTimeRange: -1,
        buttonList: [
            { label: '3 Month', count: 3 },
            { label: '6 Month', count: 6 },
            { label: '1 Year', count: 12 },
            { label: '5 Year', count: 60 },
            { label: '10 Year', count: 120 },
            { label: 'Since Inception', count: -1 }
        ]
    };

    handleChange = (event) => {
        const cnt = event.target.value;
        this.setState({
            filter: [{ count: parseInt(cnt, 10) }],
            selectedTimeRange: parseInt(cnt, 10)
        });
    };

    monthAndYearFilter = (cnt) => {
        this.setState({
            filter: [{ count: cnt }],
            selectedTimeRange: cnt
        });
    };

    render() {
        const { ticker } = this.props;
        const { filter, selectedTimeRange, buttonList } = this.state;
        // Setup x axis formatting prop to pass to line chart
        let xAxisFormat;
        if (selectedTimeRange < 60 && selectedTimeRange > 3) {
            xAxisFormat = ['%b', '%b'];
        } else if (selectedTimeRange <= 3 && selectedTimeRange > 0) {
            xAxisFormat = ['%m/%d', '%m/%d'];
        } else {
            xAxisFormat = ['%y', '%Y'];
        }
        return (
            <GqlQueryWrapper
                filter={filter}
                query={HISTORICAL_PRICE_QUERY}
                variables={{ ticker }}
                dataFunc={historicalPricesChartCardUtil}
                placeholder={() => <TablePreRender />}
            >
                {({ data: { colors, data } }) => (
                    <React.Fragment>
                        <Card>
                            <div className="container">
                                <TitleWithDescription title="Historical Prices" />
                                <ChartWrapper
                                    tipContent={(d) => {
                                        const formattedData = {
                                            ...d,
                                            label: d.headers[0],
                                            headers: [d.label]
                                        };
                                        return (
                                            <ChartTooltip
                                                data={formattedData}
                                                format={(val) =>
                                                    displayCurrency(val)
                                                }
                                            />
                                        );
                                    }}
                                >
                                    {({
                                        width,
                                        marginLeft,
                                        toggleTooltip,
                                        updateTooltip
                                    }) => (
                                        <LineChart
                                            colors={colors}
                                            data={data}
                                            width={width}
                                            height={300}
                                            marginBottom={30}
                                            marginLeft={marginLeft}
                                            toggleTooltip={toggleTooltip}
                                            updateTooltip={updateTooltip}
                                            formatXAxis={xAxisFormat}
                                        />
                                    )}
                                </ChartWrapper>
                                <TimeRangeToggle
                                    data={buttonList}
                                    selectedTimeRange={selectedTimeRange}
                                    handleChange={this.handleChange}
                                    monthAndYearFilter={this.monthAndYearFilter}
                                />
                            </div>
                            <style jsx>{styles}</style>
                        </Card>
                        <ViewDataTable
                            modalId="historical-prices-view-data"
                            audioLabel="View Data for Historical Prices in a table format"
                        >
                            <table
                                className="view-data-table"
                                title="Historical Prices Data Table"
                            >
                                <caption>Data for Historical Prices</caption>
                                <thead>
                                    <tr>
                                        <th>{data[0].headers[0]} Date</th>
                                        <th>Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map(({ label, data: rowData }) => (
                                        <tr key={label}>
                                            <td
                                                style={{
                                                    textAlign: 'right'
                                                }}
                                            >
                                                {label}
                                            </td>
                                            <td
                                                style={{
                                                    textAlign: 'right'
                                                }}
                                            >
                                                {displayCurrency(rowData[0])}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </ViewDataTable>
                    </React.Fragment>
                )}
            </GqlQueryWrapper>
        );
    }
}

export default HistoricalPricesChart;
